import { EllipsisVertical } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useDeleteFlashcardModal } from "../../stores/use-delete-flashcard-modal-store"
import { useRenameFlashcardModal } from "../../stores/use-rename-flashcard-modal-store"
import type { SetDeck } from "@/services/api/flashcards/get-all"

interface FlashcardItemMenuProps {
  flashcard: SetDeck
}

const FlashcardItemMenu = ({ flashcard }: FlashcardItemMenuProps) => {
  const { openModal: openDeleteFlashcardModal } = useDeleteFlashcardModal()
  const { openModal: openRenameFlashcardModal } = useRenameFlashcardModal()

  const handleOnRename = () => {
    openRenameFlashcardModal(flashcard)
  }

  const handleOnDelete = () => {
    openDeleteFlashcardModal(flashcard.id)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <EllipsisVertical className="h-7 w-6 rounded-[8px] text-gray-500 hover:bg-neutral-200" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {/* <DropdownMenuItem onClick={handleOnEdit} className="text-sm font-normal">
          Editar
        </DropdownMenuItem> */}
        <DropdownMenuItem onClick={handleOnRename} className="text-sm font-normal">
          Renombrar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleOnDelete} className="text-sm font-normal text-red-600">
          Eliminar
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default FlashcardItemMenu
